import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {JurisdictionZoneDataStore} from './JurisdictionZoneDataStore';
import {
    CoreDI,
    ElapsedClockCounter,
    GameConfig,
    getCurrentTime,
    IEventManagerWithAsync,
    inject,
    LanguageService,
    SlotSettings,
} from '@gongxigames/framework/slot';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class JurisdictionZoneDataService extends UiServiceV2 {
    public static readonly NAME = 'JurisdictionZoneDataService';

    @inject(CoreDI.LanguageService)
    private _languageService!: LanguageService;

    @inject(CoreDI.Settings)
    private _settings!: SlotSettings;

    @inject(CoreDI.GameConfig)
    protected _gameConfig!: GameConfig;

    @inject(CoreDI.IEventManagerWithAsync)
    protected _eventManager!: IEventManagerWithAsync;

    // TODO: refactor it and do not use stuff from clotV1
    private elapsedClockCounter: ElapsedClockCounter = new ElapsedClockCounter();

    private sessionBets = 0;
    private sessionEarnings = 0;
    private actionNumberForSessionEarnings = -1;

    onInit(): void {
        const jStore = JurisdictionZoneDataStore;

        jStore.jurisdictionData_gameName_enabled.value = true;
        jStore.jurisdictionData_pointsBalance_enabled.value = !!this._settings.get('isPointsCurrencyEnabled');
        jStore.jurisdictionData_clock_enabled.value = this._settings.get('clock');
        jStore.jurisdictionData_elapsedTime_enabled.value = this._settings.get('elapsedTimeEnabled');
        jStore.jurisdictionData_netPosition_enabled.value = this._settings.get('netPositionEnabled');
        jStore.jurisdictionData_sessionEarnings_enabled.value = this._settings.get('sessionEarningsEnabled');
        jStore.jurisdictionData_sessionBets_enabled.value = this._settings.get('sessionBetsEnabled');
        jStore.jurisdictionData_showMaxWinProbability_enabled.value = this._settings.get('showMaxWinProbabilityOnUI');
        jStore.jurisdictionData_RTPWatermark_enabled.value = this._settings.get('showRTPWatermark');

        jStore.jurisdictionData_gameName.value = this.getGameName();
        jStore.jurisdictionData_showMaxWinProbability.value = this._gameConfig.winProbability;
        jStore.jurisdictionData_RTPWatermark.value = this._gameConfig.RTP;

        this.elapsedClockCounter.init(Date.now(), this._eventManager);
    }

    onSetupEvents() {
        this.emitter.on('LogicEvents.POINTS_BALANCE_UPDATED', this.updatePointsBalance);
        this.emitter.on('General.Game.STARTED', this.onGameStarted.bind(this));
        this.emitter.on('Game.command.refreshBalance', this.onBalanceUpdated.bind(this));
        this.emitter.on('UI.command.updateSessionBet', this.updateSessionBet.bind(this));

        // this.emitter.on('CORE.screen.resize', this.onResize.bind(this));
    }

    private onGameStarted() {
        this.updateSessionNetBalance();
        this.runClocks();
        this.updatePointsBalance();
        this.updateSessionEarnings();
    }

    private getGameName(): string {
        const localizeGameName = this._languageService.get('gameName');
        const str = localizeGameName === 'undefined' ? this._gameConfig.gameName : localizeGameName;

        return str.toUpperCase();
    }

    private updatePointsBalance(points = 0): void {
        JurisdictionZoneDataStore
            .jurisdictionData_pointsBalance
            .value = slotStore.currencyFormatter.value!.formatCents(points);
    }

    protected runClocks(): void {
        slotStore
            .updateManager
            .value
            ?.addTimer(this.runClocks.bind(this), 1000, true);

        this.updateClock();
        this.updateElapsedTime();
    }

    private updateClock(): void {
        JurisdictionZoneDataStore
            .jurisdictionData_clock
            .value = getCurrentTime();
    }

    private updateElapsedTime(): void {
        if (!this.elapsedClockCounter.isPaused) {
            JurisdictionZoneDataStore
                .jurisdictionData_elapsedTime
                .value = this.elapsedClockCounter.getTime();
        }
    }

    private updateSessionNetBalance(): void {
        const sessionNetBalance = this.sessionEarnings - this.sessionBets;

        JurisdictionZoneDataStore
            .jurisdictionData_netPosition
            .value = slotStore.currencyFormatter.value?.formatCents(sessionNetBalance) || '';
    }

    private addSessionEarnings(): void {
        const actionNumber = slotStore.actionNumber.value;

        if (slotStore.logic_nextActionIsSpin.value && this.actionNumberForSessionEarnings !== actionNumber) {
            this.sessionEarnings += slotStore.logic_totalWin.value;
            this.actionNumberForSessionEarnings = actionNumber;
        }
    }

    private updateSessionEarnings(): void {
        this.addSessionEarnings();

        JurisdictionZoneDataStore
            .jurisdictionData_sessionEarnings
            .value = slotStore.currencyFormatter.value?.formatCents(this.sessionEarnings) || '';
    }

    private onBalanceUpdated(): void {
        this.updateSessionEarnings();
        this.updateSessionNetBalance();
    }

    private updateSessionBet(): void {
        if (slotStore.logic_nextAction.value === Action.SPIN) {
            this.sessionBets += slotStore.logic_totalBet.value;
        }
    }
}